import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

function FeriencampsManager() {
    const { user } = useAuth();
    const [events, setEvents] = useState([]);
    const [bookings, setBookings] = useState([]);
    const [bundles, setBundles] = useState([]);
    const [bundleBookings, setBundleBookings] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [editingEvent, setEditingEvent] = useState(null);
    const [showBundleForm, setShowBundleForm] = useState(false);
    const [editingBundle, setEditingBundle] = useState(null);
    const [activeTab, setActiveTab] = useState('events');
    const [creatingMembers, setCreatingMembers] = useState(false);
    const [memberResults, setMemberResults] = useState(null);

    const [bundleFormData, setBundleFormData] = useState({
        title: '',
        event_ids: [],
        price: '',
        price_sibling: '',
        price_member: '',
        price_member_sibling: '',
        early_bird_deadline: '',
        price_early_bird: '',
        price_early_bird_sibling: '',
        price_early_bird_member: '',
        price_early_bird_member_sibling: '',
        description: ''
    });

    const [formData, setFormData] = useState({
        start_date: '',
        end_date: '',
        time: '09:00',
        duration: 360,
        max_participants: 15,
        title: '',
        age_group: '',
        price: '',
        price_sibling: '',
        price_member: '',
        price_member_sibling: '',
        early_bird_deadline: '',
        price_early_bird: '',
        price_early_bird_sibling: '',
        price_early_bird_member: '',
        price_early_bird_member_sibling: '',
        description: '',
        notes: ''
    });

    useEffect(() => {
        fetchEvents();
        fetchBookings();
        fetchBundles();
        fetchBundleBookings();
    }, []);

    const fetchEvents = () => {
        fetch('/api/feriencamp-events')
            .then(res => res.json())
            .then(data => setEvents(data.data || []))
            .catch(err => console.error('Fehler beim Laden der Feriencamps:', err));
    };

    const fetchBookings = () => {
        fetch('/api/feriencamp-bookings')
            .then(res => res.json())
            .then(data => setBookings(data.data || []))
            .catch(err => console.error('Fehler beim Laden der Buchungen:', err));
    };

    const fetchBundles = () => {
        fetch('/api/feriencamp-bundles')
            .then(res => res.json())
            .then(data => setBundles(data.data || []))
            .catch(err => console.error('Fehler beim Laden der Bundles:', err));
    };

    const fetchBundleBookings = () => {
        fetch('/api/feriencamp-bundle-bookings')
            .then(res => res.json())
            .then(data => setBundleBookings(data.data || []))
            .catch(err => console.error('Fehler beim Laden der Bundle-Anmeldungen:', err));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const url = editingEvent
            ? `/api/feriencamp-events/${editingEvent.id}`
            : '/api/feriencamp-events';
        const method = editingEvent ? 'PUT' : 'POST';

        // Validierung
        if (!formData.start_date || !formData.end_date || !formData.time || !formData.title) {
            alert('Bitte Startdatum, Enddatum, Uhrzeit und Titel ausfuellen.');
            return;
        }

        const submitData = {
            start_date: formData.start_date,
            end_date: formData.end_date,
            time: formData.time,
            duration: parseInt(formData.duration) || 360,
            max_participants: parseInt(formData.max_participants) || 15,
            title: formData.title,
            age_group: formData.age_group || null,
            price: formData.price ? parseFloat(formData.price) : null,
            price_sibling: formData.price_sibling ? parseFloat(formData.price_sibling) : null,
            price_member: formData.price_member ? parseFloat(formData.price_member) : null,
            price_member_sibling: formData.price_member_sibling ? parseFloat(formData.price_member_sibling) : null,
            early_bird_deadline: formData.early_bird_deadline || null,
            price_early_bird: formData.price_early_bird ? parseFloat(formData.price_early_bird) : null,
            price_early_bird_sibling: formData.price_early_bird_sibling ? parseFloat(formData.price_early_bird_sibling) : null,
            price_early_bird_member: formData.price_early_bird_member ? parseFloat(formData.price_early_bird_member) : null,
            price_early_bird_member_sibling: formData.price_early_bird_member_sibling ? parseFloat(formData.price_early_bird_member_sibling) : null,
            description: formData.description || null,
            notes: formData.notes || null
        };

        fetch(url, {
            method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(submitData)
        })
            .then(res => {
                if (!res.ok) {
                    return res.json().then(data => {
                        throw new Error(data.error || `HTTP ${res.status}`);
                    });
                }
                return res.json();
            })
            .then(data => {
                if (data.message === 'success') {
                    fetchEvents();
                    resetForm();
                } else {
                    alert('Fehler: ' + (data.error || 'Unbekannter Fehler'));
                }
            })
            .catch(err => {
                console.error('Fehler beim Speichern:', err);
                alert('Fehler beim Speichern: ' + err.message);
            });
    };

    const handleEdit = (event) => {
        setEditingEvent(event);
        setFormData({
            start_date: event.start_date,
            end_date: event.end_date,
            time: event.time,
            duration: event.duration,
            max_participants: event.max_participants,
            title: event.title,
            age_group: event.age_group || '',
            price: event.price || '',
            price_sibling: event.price_sibling || '',
            price_member: event.price_member || '',
            price_member_sibling: event.price_member_sibling || '',
            early_bird_deadline: event.early_bird_deadline || '',
            price_early_bird: event.price_early_bird || '',
            price_early_bird_sibling: event.price_early_bird_sibling || '',
            price_early_bird_member: event.price_early_bird_member || '',
            price_early_bird_member_sibling: event.price_early_bird_member_sibling || '',
            description: event.description || '',
            notes: event.notes || ''
        });
        setShowForm(true);
    };

    const handleDelete = (id) => {
        if (!window.confirm('Feriencamp wirklich loeschen? Alle Buchungen werden ebenfalls geloescht.')) {
            return;
        }

        fetch(`/api/feriencamp-events/${id}`, { method: 'DELETE' })
            .then(res => res.json())
            .then(data => {
                if (data.message === 'success') {
                    fetchEvents();
                    fetchBookings();
                }
            })
            .catch(err => console.error('Fehler beim Loeschen:', err));
    };

    const handleCancelBooking = (id) => {
        if (!window.confirm('Buchung wirklich stornieren?')) {
            return;
        }

        fetch(`/api/feriencamp-bookings/${id}`, { method: 'DELETE' })
            .then(res => res.json())
            .then(data => {
                if (data.message === 'success') {
                    fetchBookings();
                    fetchEvents();
                }
            })
            .catch(err => console.error('Fehler beim Stornieren:', err));
    };

    const handleResendConfirmation = (id) => {
        fetch(`/api/feriencamp-bookings/${id}/resend-confirmation`, { method: 'POST' })
            .then(res => res.json())
            .then(data => {
                if (data.message === 'success') {
                    alert('Bestaetigungs-E-Mail wurde erneut gesendet!');
                } else {
                    alert('Fehler: ' + (data.error || 'E-Mail konnte nicht gesendet werden'));
                }
            })
            .catch(err => {
                console.error('Fehler beim Senden:', err);
                alert('Fehler beim Senden der E-Mail');
            });
    };

    const handleBundleSubmit = (e) => {
        e.preventDefault();

        if (!bundleFormData.title || bundleFormData.event_ids.length < 2) {
            alert('Bitte Titel angeben und mindestens zwei Wochen auswaehlen.');
            return;
        }

        const url = editingBundle
            ? `/api/feriencamp-bundles/${editingBundle.id}`
            : '/api/feriencamp-bundles';
        const method = editingBundle ? 'PUT' : 'POST';

        const submitData = {
            title: bundleFormData.title,
            event_ids: bundleFormData.event_ids.map(id => parseInt(id)),
            price: bundleFormData.price ? parseFloat(bundleFormData.price) : null,
            price_sibling: bundleFormData.price_sibling ? parseFloat(bundleFormData.price_sibling) : null,
            price_member: bundleFormData.price_member ? parseFloat(bundleFormData.price_member) : null,
            price_member_sibling: bundleFormData.price_member_sibling ? parseFloat(bundleFormData.price_member_sibling) : null,
            early_bird_deadline: bundleFormData.early_bird_deadline || null,
            price_early_bird: bundleFormData.price_early_bird ? parseFloat(bundleFormData.price_early_bird) : null,
            price_early_bird_sibling: bundleFormData.price_early_bird_sibling ? parseFloat(bundleFormData.price_early_bird_sibling) : null,
            price_early_bird_member: bundleFormData.price_early_bird_member ? parseFloat(bundleFormData.price_early_bird_member) : null,
            price_early_bird_member_sibling: bundleFormData.price_early_bird_member_sibling ? parseFloat(bundleFormData.price_early_bird_member_sibling) : null,
            description: bundleFormData.description || null
        };

        fetch(url, {
            method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(submitData)
        })
            .then(res => {
                if (!res.ok) {
                    return res.json().then(data => { throw new Error(data.error || `HTTP ${res.status}`); });
                }
                return res.json();
            })
            .then(data => {
                if (data.message === 'success') {
                    fetchBundles();
                    resetBundleForm();
                } else {
                    alert('Fehler: ' + (data.error || 'Unbekannter Fehler'));
                }
            })
            .catch(err => {
                console.error('Fehler beim Speichern des Bundles:', err);
                alert('Fehler beim Speichern: ' + err.message);
            });
    };

    const handleEditBundle = (bundle) => {
        setEditingBundle(bundle);
        setBundleFormData({
            title: bundle.title,
            event_ids: (bundle.events || []).map(e => e.id),
            price: bundle.price || '',
            price_sibling: bundle.price_sibling || '',
            price_member: bundle.price_member || '',
            price_member_sibling: bundle.price_member_sibling || '',
            early_bird_deadline: bundle.early_bird_deadline || '',
            price_early_bird: bundle.price_early_bird || '',
            price_early_bird_sibling: bundle.price_early_bird_sibling || '',
            price_early_bird_member: bundle.price_early_bird_member || '',
            price_early_bird_member_sibling: bundle.price_early_bird_member_sibling || '',
            description: bundle.description || ''
        });
        setShowBundleForm(true);
    };

    const handleDeleteBundle = (id) => {
        if (!window.confirm('Bundle wirklich loeschen? Bestehende Bundle-Anmeldungen werden ebenfalls geloescht.')) {
            return;
        }

        fetch(`/api/feriencamp-bundles/${id}`, { method: 'DELETE' })
            .then(res => res.json())
            .then(data => {
                if (data.message === 'success') {
                    fetchBundles();
                    fetchBundleBookings();
                    fetchEvents();
                    fetchBookings();
                }
            })
            .catch(err => console.error('Fehler beim Loeschen des Bundles:', err));
    };

    const resetBundleForm = () => {
        setShowBundleForm(false);
        setEditingBundle(null);
        setBundleFormData({
            title: '',
            event_ids: [],
            price: '',
            price_sibling: '',
            price_member: '',
            price_member_sibling: '',
            early_bird_deadline: '',
            price_early_bird: '',
            price_early_bird_sibling: '',
            price_early_bird_member: '',
            price_early_bird_member_sibling: '',
            description: ''
        });
    };

    const toggleBundleEvent = (eventId) => {
        setBundleFormData(prev => {
            const exists = prev.event_ids.includes(eventId);
            return {
                ...prev,
                event_ids: exists ? prev.event_ids.filter(id => id !== eventId) : [...prev.event_ids, eventId]
            };
        });
    };

    const handleCancelBundleBooking = (id) => {
        if (!window.confirm('Bundle-Buchung wirklich stornieren? Alle enthaltenen Wochen werden mit storniert.')) {
            return;
        }

        fetch(`/api/feriencamp-bundle-bookings/${id}`, { method: 'DELETE' })
            .then(res => res.json())
            .then(data => {
                if (data.message === 'success') {
                    fetchBundleBookings();
                    fetchBookings();
                    fetchEvents();
                }
            })
            .catch(err => console.error('Fehler beim Stornieren der Bundle-Buchung:', err));
    };

    const handleResendBundleConfirmation = (id) => {
        fetch(`/api/feriencamp-bundle-bookings/${id}/resend-confirmation`, { method: 'POST' })
            .then(res => res.json())
            .then(data => {
                if (data.message === 'success') {
                    alert('Bestaetigungs-E-Mail wurde erneut gesendet!');
                } else {
                    alert('Fehler: ' + (data.error || 'E-Mail konnte nicht gesendet werden'));
                }
            })
            .catch(err => {
                console.error('Fehler beim Senden:', err);
                alert('Fehler beim Senden der E-Mail');
            });
    };

    const handleSendInfoToAll = (eventId, eventTitle) => {
        const eventBookings = bookingsByEvent[eventId]?.bookings || [];
        if (eventBookings.length === 0) {
            alert('Keine Anmeldungen fuer dieses Feriencamp.');
            return;
        }

        if (!window.confirm(`Info-E-Mail an alle ${eventBookings.length} Teilnehmer von "${eventTitle}" senden?`)) {
            return;
        }

        fetch(`/api/feriencamp-events/${eventId}/send-info-email`, { method: 'POST' })
            .then(res => res.json())
            .then(data => {
                if (data.message === 'success') {
                    alert(`Info-E-Mail an ${data.sent} Teilnehmer gesendet!`);
                } else {
                    alert('Fehler: ' + (data.error || 'E-Mails konnten nicht gesendet werden'));
                }
            })
            .catch(err => {
                console.error('Fehler beim Senden:', err);
                alert('Fehler beim Senden der E-Mails');
            });
    };

    const resetForm = () => {
        setShowForm(false);
        setEditingEvent(null);
        setFormData({
            start_date: '',
            end_date: '',
            time: '09:00',
            duration: 360,
            max_participants: 15,
            title: '',
            age_group: '',
            price: '',
            price_sibling: '',
            price_member: '',
            price_member_sibling: '',
            early_bird_deadline: '',
            price_early_bird: '',
            price_early_bird_sibling: '',
            price_early_bird_member: '',
            price_early_bird_member_sibling: '',
            description: '',
            notes: ''
        });
    };

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' });
    };

    const formatDateRange = (startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const startStr = start.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' });
        const endStr = end.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
        return `${startStr} - ${endStr}`;
    };

    const formatPrice = (price) => {
        if (!price) return '-';
        return parseFloat(price).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    };

    const createMembersFromBookings = (eventId) => {
        if (!window.confirm('Mitglieder-Accounts fuer alle Anmeldungen dieses Feriencamps erstellen?\n\nEltern mit gleicher E-Mail-Adresse werden nur einmal angelegt.')) {
            return;
        }

        setCreatingMembers(true);
        setMemberResults(null);

        fetch(`/api/members/from-feriencamp-event/${eventId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user?.token}`
            }
        })
            .then(res => res.json())
            .then(data => {
                if (data.message === 'success') {
                    setMemberResults({
                        success: true,
                        created: data.data.created,
                        skipped: data.data.skipped,
                        members: data.members || []
                    });
                } else {
                    setMemberResults({ success: false, error: data.error });
                }
            })
            .catch(err => {
                setMemberResults({ success: false, error: err.message });
            })
            .finally(() => setCreatingMembers(false));
    };

    // Gruppiere Buchungen nach Event
    const bookingsByEvent = {};
    bookings.forEach(b => {
        if (!bookingsByEvent[b.event_id]) {
            bookingsByEvent[b.event_id] = {
                title: b.event_title,
                start_date: b.start_date,
                end_date: b.end_date,
                bookings: []
            };
        }
        bookingsByEvent[b.event_id].bookings.push(b);
    });

    return (
        <div className="container-fluid">
            <h4>Feriencamps verwalten</h4>

            {/* Tabs */}
            <ul className="nav nav-tabs mb-3">
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeTab === 'events' ? 'active' : ''}`}
                        onClick={() => setActiveTab('events')}
                    >
                        Feriencamps ({events.length})
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeTab === 'bundles' ? 'active' : ''}`}
                        onClick={() => setActiveTab('bundles')}
                    >
                        Bundles ({bundles.length})
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeTab === 'bookings' ? 'active' : ''}`}
                        onClick={() => setActiveTab('bookings')}
                    >
                        Anmeldungen ({bookings.length + bundleBookings.length})
                    </button>
                </li>
            </ul>

            {/* Events Tab */}
            {activeTab === 'events' && (
                <>
                    <button className="btn btn-primary mb-3" onClick={() => setShowForm(true)}>
                        + Neues Feriencamp
                    </button>

                    {showForm && (
                        <div className="card mb-4">
                            <div className="card-body">
                                <h5>{editingEvent ? 'Feriencamp bearbeiten' : 'Neues Feriencamp'}</h5>
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Startdatum *</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={formData.start_date}
                                                onChange={e => setFormData({ ...formData, start_date: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Enddatum *</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={formData.end_date}
                                                onChange={e => setFormData({ ...formData, end_date: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-2 mb-3">
                                            <label className="form-label">Taegliche Startzeit *</label>
                                            <input
                                                type="time"
                                                className="form-control"
                                                value={formData.time}
                                                onChange={e => setFormData({ ...formData, time: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-2 mb-3">
                                            <label className="form-label">Dauer/Tag (Min)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={formData.duration}
                                                onChange={e => setFormData({ ...formData, duration: parseInt(e.target.value) })}
                                                min="60"
                                                step="30"
                                            />
                                        </div>
                                        <div className="col-md-2 mb-3">
                                            <label className="form-label">Max. Teilnehmer</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={formData.max_participants}
                                                onChange={e => setFormData({ ...formData, max_participants: parseInt(e.target.value) })}
                                                min="1"
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Titel *</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.title}
                                                onChange={e => setFormData({ ...formData, title: e.target.value })}
                                                placeholder="z.B. Minecraft Baumeister Camp"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Altersgruppe</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.age_group}
                                                onChange={e => setFormData({ ...formData, age_group: e.target.value })}
                                                placeholder="z.B. 8-12 Jahre"
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Normalpreis (EUR)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={formData.price}
                                                onChange={e => setFormData({ ...formData, price: e.target.value })}
                                                placeholder="z.B. 199.00"
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Geschwisterkind (EUR)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={formData.price_sibling}
                                                onChange={e => setFormData({ ...formData, price_sibling: e.target.value })}
                                                placeholder="z.B. 179.00"
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Mitglieder (EUR)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={formData.price_member}
                                                onChange={e => setFormData({ ...formData, price_member: e.target.value })}
                                                placeholder="z.B. 169.00"
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Mitgl. Geschw. (EUR)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={formData.price_member_sibling}
                                                onChange={e => setFormData({ ...formData, price_member_sibling: e.target.value })}
                                                placeholder="z.B. 149.00"
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>
                                    </div>
                                    <div className="card mb-3" style={{ background: '#fff3cd', border: '1px solid #ffc107' }}>
                                        <div className="card-body py-2">
                                            <h6 className="mb-2" style={{ color: '#856404' }}>Fruehbucher-Preise (optional)</h6>
                                            <div className="row">
                                                <div className="col-md-4 mb-2">
                                                    <label className="form-label small">Fruehbucher bis</label>
                                                    <input
                                                        type="date"
                                                        className="form-control form-control-sm"
                                                        value={formData.early_bird_deadline}
                                                        onChange={e => setFormData({ ...formData, early_bird_deadline: e.target.value })}
                                                    />
                                                </div>
                                                <div className="col-md-2 mb-2">
                                                    <label className="form-label small">Normal</label>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={formData.price_early_bird}
                                                        onChange={e => setFormData({ ...formData, price_early_bird: e.target.value })}
                                                        placeholder="199.00"
                                                        step="0.01"
                                                        min="0"
                                                    />
                                                </div>
                                                <div className="col-md-2 mb-2">
                                                    <label className="form-label small">Geschwister</label>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={formData.price_early_bird_sibling}
                                                        onChange={e => setFormData({ ...formData, price_early_bird_sibling: e.target.value })}
                                                        placeholder="179.00"
                                                        step="0.01"
                                                        min="0"
                                                    />
                                                </div>
                                                <div className="col-md-2 mb-2">
                                                    <label className="form-label small">Mitglieder</label>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={formData.price_early_bird_member}
                                                        onChange={e => setFormData({ ...formData, price_early_bird_member: e.target.value })}
                                                        placeholder="179.00"
                                                        step="0.01"
                                                        min="0"
                                                    />
                                                </div>
                                                <div className="col-md-2 mb-2">
                                                    <label className="form-label small">Mitgl. Geschw.</label>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={formData.price_early_bird_member_sibling}
                                                        onChange={e => setFormData({ ...formData, price_early_bird_member_sibling: e.target.value })}
                                                        placeholder="159.00"
                                                        step="0.01"
                                                        min="0"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Beschreibung (oeffentlich)</label>
                                        <textarea
                                            className="form-control"
                                            rows="3"
                                            value={formData.description}
                                            onChange={e => setFormData({ ...formData, description: e.target.value })}
                                            placeholder="Was erwartet die Kinder? Was werden wir machen?"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Notizen (intern)</label>
                                        <textarea
                                            className="form-control"
                                            rows="2"
                                            value={formData.notes}
                                            onChange={e => setFormData({ ...formData, notes: e.target.value })}
                                        />
                                    </div>
                                    <div className="d-flex gap-2">
                                        <button type="submit" className="btn btn-success">
                                            {editingEvent ? 'Speichern' : 'Erstellen'}
                                        </button>
                                        <button type="button" className="btn btn-secondary" onClick={resetForm}>
                                            Abbrechen
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}

                    {events.length === 0 ? (
                        <div className="alert alert-info">
                            Noch keine Feriencamps angelegt. Klicke auf "Neues Feriencamp" um loszulegen.
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Zeitraum</th>
                                        <th>Titel</th>
                                        <th>Altersgruppe</th>
                                        <th>Preis</th>
                                        <th>Anmeldungen</th>
                                        <th>Aktionen</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {events.map(event => (
                                        <tr key={event.id}>
                                            <td>
                                                {formatDateRange(event.start_date, event.end_date)}
                                                <br />
                                                <small className="text-muted">taeglich ab {event.time} Uhr</small>
                                            </td>
                                            <td>{event.title}</td>
                                            <td>
                                                {event.age_group ? (
                                                    <span className="badge bg-info">{event.age_group}</span>
                                                ) : '-'}
                                            </td>
                                            <td>{formatPrice(event.price)}</td>
                                            <td>
                                                <span className={`badge ${event.booked_count >= event.max_participants ? 'bg-danger' : event.booked_count > 0 ? 'bg-warning' : 'bg-success'}`}>
                                                    {event.booked_count} / {event.max_participants}
                                                </span>
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-sm btn-outline-primary me-1"
                                                    onClick={() => handleEdit(event)}
                                                >
                                                    Bearbeiten
                                                </button>
                                                {event.booked_count > 0 && (
                                                    <button
                                                        className="btn btn-sm btn-outline-success me-1"
                                                        onClick={() => handleSendInfoToAll(event.id, event.title)}
                                                        title="Info-E-Mail an alle Teilnehmer senden"
                                                    >
                                                        Info an alle
                                                    </button>
                                                )}
                                                <button
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => handleDelete(event.id)}
                                                >
                                                    Loeschen
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </>
            )}

            {/* Bundles Tab */}
            {activeTab === 'bundles' && (
                <>
                    <p className="text-muted">
                        Bundles fassen mehrere Feriencamp-Wochen zu einem Vorteilspreis zusammen (z.B. Duo- oder All-In-Ticket).
                        Eine Buchung legt automatisch eine Anmeldung fuer jede enthaltene Woche an.
                    </p>
                    <button className="btn btn-primary mb-3" onClick={() => setShowBundleForm(true)}>
                        + Neues Bundle
                    </button>

                    {showBundleForm && (
                        <div className="card mb-4">
                            <div className="card-body">
                                <h5>{editingBundle ? 'Bundle bearbeiten' : 'Neues Bundle'}</h5>
                                <form onSubmit={handleBundleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">Titel *</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={bundleFormData.title}
                                            onChange={e => setBundleFormData({ ...bundleFormData, title: e.target.value })}
                                            placeholder="z.B. All-In Sommer (3 Wochen)"
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Enthaltene Wochen * (mind. 2)</label>
                                        {events.length === 0 ? (
                                            <div className="text-muted small">Erst Feriencamp-Wochen im Tab "Feriencamps" anlegen.</div>
                                        ) : (
                                            <div className="row">
                                                {events.map(event => (
                                                    <div className="col-md-6" key={event.id}>
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id={`bundle-event-${event.id}`}
                                                                checked={bundleFormData.event_ids.includes(event.id)}
                                                                onChange={() => toggleBundleEvent(event.id)}
                                                            />
                                                            <label className="form-check-label" htmlFor={`bundle-event-${event.id}`}>
                                                                {event.title} ({formatDateRange(event.start_date, event.end_date)})
                                                            </label>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    <div className="row">
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Normalpreis (EUR)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={bundleFormData.price}
                                                onChange={e => setBundleFormData({ ...bundleFormData, price: e.target.value })}
                                                placeholder="z.B. 559.00"
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Geschwisterkind (EUR)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={bundleFormData.price_sibling}
                                                onChange={e => setBundleFormData({ ...bundleFormData, price_sibling: e.target.value })}
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Mitglieder (EUR)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={bundleFormData.price_member}
                                                onChange={e => setBundleFormData({ ...bundleFormData, price_member: e.target.value })}
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Mitgl. Geschw. (EUR)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={bundleFormData.price_member_sibling}
                                                onChange={e => setBundleFormData({ ...bundleFormData, price_member_sibling: e.target.value })}
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>
                                    </div>

                                    <div className="card mb-3" style={{ background: '#fff3cd', border: '1px solid #ffc107' }}>
                                        <div className="card-body py-2">
                                            <h6 className="mb-2" style={{ color: '#856404' }}>Fruehbucher-Preise (optional)</h6>
                                            <div className="row">
                                                <div className="col-md-4 mb-2">
                                                    <label className="form-label small">Fruehbucher bis</label>
                                                    <input
                                                        type="date"
                                                        className="form-control form-control-sm"
                                                        value={bundleFormData.early_bird_deadline}
                                                        onChange={e => setBundleFormData({ ...bundleFormData, early_bird_deadline: e.target.value })}
                                                    />
                                                </div>
                                                <div className="col-md-2 mb-2">
                                                    <label className="form-label small">Normal</label>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={bundleFormData.price_early_bird}
                                                        onChange={e => setBundleFormData({ ...bundleFormData, price_early_bird: e.target.value })}
                                                        step="0.01"
                                                        min="0"
                                                    />
                                                </div>
                                                <div className="col-md-2 mb-2">
                                                    <label className="form-label small">Geschwister</label>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={bundleFormData.price_early_bird_sibling}
                                                        onChange={e => setBundleFormData({ ...bundleFormData, price_early_bird_sibling: e.target.value })}
                                                        step="0.01"
                                                        min="0"
                                                    />
                                                </div>
                                                <div className="col-md-2 mb-2">
                                                    <label className="form-label small">Mitglieder</label>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={bundleFormData.price_early_bird_member}
                                                        onChange={e => setBundleFormData({ ...bundleFormData, price_early_bird_member: e.target.value })}
                                                        step="0.01"
                                                        min="0"
                                                    />
                                                </div>
                                                <div className="col-md-2 mb-2">
                                                    <label className="form-label small">Mitgl. Geschw.</label>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={bundleFormData.price_early_bird_member_sibling}
                                                        onChange={e => setBundleFormData({ ...bundleFormData, price_early_bird_member_sibling: e.target.value })}
                                                        step="0.01"
                                                        min="0"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Beschreibung (oeffentlich)</label>
                                        <textarea
                                            className="form-control"
                                            rows="3"
                                            value={bundleFormData.description}
                                            onChange={e => setBundleFormData({ ...bundleFormData, description: e.target.value })}
                                            placeholder="Was ist in diesem Bundle enthalten?"
                                        />
                                    </div>

                                    <div className="d-flex gap-2">
                                        <button type="submit" className="btn btn-success">
                                            {editingBundle ? 'Speichern' : 'Erstellen'}
                                        </button>
                                        <button type="button" className="btn btn-secondary" onClick={resetBundleForm}>
                                            Abbrechen
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}

                    {bundles.length === 0 ? (
                        <div className="alert alert-info">
                            Noch keine Bundles angelegt. Klicke auf "Neues Bundle" um loszulegen.
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Titel</th>
                                        <th>Enthaltene Wochen</th>
                                        <th>Preis</th>
                                        <th>Anmeldungen</th>
                                        <th>Aktionen</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bundles.map(bundle => (
                                        <tr key={bundle.id}>
                                            <td>{bundle.title}</td>
                                            <td>
                                                {(bundle.events || []).map(e => (
                                                    <div key={e.id}>
                                                        <small>{e.title} ({formatDateRange(e.start_date, e.end_date)})</small>
                                                    </div>
                                                ))}
                                            </td>
                                            <td>{formatPrice(bundle.price)}</td>
                                            <td>
                                                <span className="badge bg-secondary">{bundle.booked_count}</span>
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-sm btn-outline-primary me-1"
                                                    onClick={() => handleEditBundle(bundle)}
                                                >
                                                    Bearbeiten
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => handleDeleteBundle(bundle.id)}
                                                >
                                                    Loeschen
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </>
            )}

            {/* Bookings Tab */}
            {activeTab === 'bookings' && (
                <>
                    {/* Mitglieder erstellen - Aktionen pro Event */}
                    {Object.keys(bookingsByEvent).length > 0 && (
                        <div className="card mb-4">
                            <div className="card-header">
                                <strong>Mitglieder aus Anmeldungen erstellen</strong>
                            </div>
                            <div className="card-body">
                                <p className="text-muted small mb-3">
                                    Erstellt Mitglieder-Accounts mit Typ "feriencamp" fuer alle Eltern.
                                    Zugangsdaten werden generiert und angezeigt.
                                </p>
                                <div className="d-flex flex-wrap gap-2">
                                    {Object.entries(bookingsByEvent).map(([eventId, eventData]) => (
                                        <button
                                            key={eventId}
                                            className="btn btn-success"
                                            onClick={() => createMembersFromBookings(eventId)}
                                            disabled={creatingMembers}
                                        >
                                            {creatingMembers ? 'Wird erstellt...' : `${eventData.title} (${eventData.bookings.length} Anmeldungen)`}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Ergebnis der Mitglieder-Erstellung */}
                    {memberResults && (
                        <div className={`alert ${memberResults.success ? 'alert-success' : 'alert-danger'} alert-dismissible`}>
                            <button type="button" className="btn-close" onClick={() => setMemberResults(null)}></button>
                            {memberResults.success ? (
                                <>
                                    <strong>{memberResults.created} Mitglieder erstellt</strong>
                                    {memberResults.skipped > 0 && ` (${memberResults.skipped} uebersprungen - existierten bereits)`}

                                    {memberResults.members && memberResults.members.length > 0 && (
                                        <div className="mt-3">
                                            <strong>Zugangsdaten (bitte notieren!):</strong>
                                            <table className="table table-sm table-bordered mt-2 bg-white">
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>E-Mail</th>
                                                        <th>Benutzername</th>
                                                        <th>Passwort</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {memberResults.members.map((m, idx) => (
                                                        <tr key={idx}>
                                                            <td>{m.parent_name}</td>
                                                            <td>{m.email}</td>
                                                            <td><code>{m.username}</code></td>
                                                            <td><code>{m.tempPassword}</code></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <strong>Fehler: {memberResults.error}</strong>
                            )}
                        </div>
                    )}

                    {bookings.length === 0 ? (
                        <div className="alert alert-info">
                            Noch keine Anmeldungen vorhanden.
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Feriencamp</th>
                                        <th>Name</th>
                                        <th>Kontakt</th>
                                        <th>Kind</th>
                                        <th>Nachricht</th>
                                        <th>Status</th>
                                        <th>Aktionen</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bookings.map(booking => (
                                        <tr key={booking.id}>
                                            <td>
                                                {formatDateRange(booking.start_date, booking.end_date)}<br />
                                                <small className="text-muted">{booking.event_title}</small>
                                                {booking.bundle_booking_id && <><br /><span className="badge bg-info">Teil eines Bundles</span></>}
                                            </td>
                                            <td>{booking.parent_name}</td>
                                            <td>
                                                <a href={`mailto:${booking.email}`}>{booking.email}</a>
                                                {booking.phone && <><br /><small>{booking.phone}</small></>}
                                            </td>
                                            <td>
                                                {booking.child_name || '-'}
                                                {booking.child_age && <><br /><small>{booking.child_age} Jahre</small></>}
                                            </td>
                                            <td>
                                                <small>{booking.message || '-'}</small>
                                            </td>
                                            <td>
                                                <span className={`badge ${booking.status === 'confirmed' ? 'bg-success' : 'bg-secondary'}`}>
                                                    {booking.status === 'confirmed' ? 'Bestaetigt' : booking.status}
                                                </span>
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-sm btn-outline-primary me-1"
                                                    onClick={() => handleResendConfirmation(booking.id)}
                                                    title="Bestaetigungs-E-Mail erneut senden"
                                                >
                                                    E-Mail
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => handleCancelBooking(booking.id)}
                                                >
                                                    Stornieren
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    <h5 className="mt-5">Bundle-Anmeldungen</h5>
                    {bundleBookings.length === 0 ? (
                        <div className="alert alert-info">
                            Noch keine Bundle-Anmeldungen vorhanden.
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Bundle</th>
                                        <th>Enthaltene Wochen</th>
                                        <th>Name</th>
                                        <th>Kontakt</th>
                                        <th>Kind</th>
                                        <th>Status</th>
                                        <th>Aktionen</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bundleBookings.map(booking => (
                                        <tr key={booking.id}>
                                            <td>{booking.bundle_title}</td>
                                            <td>
                                                {(booking.events || []).map(e => (
                                                    <div key={e.id}>
                                                        <small>{e.title} ({formatDateRange(e.start_date, e.end_date)})</small>
                                                    </div>
                                                ))}
                                            </td>
                                            <td>{booking.parent_name}</td>
                                            <td>
                                                <a href={`mailto:${booking.email}`}>{booking.email}</a>
                                                {booking.phone && <><br /><small>{booking.phone}</small></>}
                                            </td>
                                            <td>
                                                {booking.child_name || '-'}
                                                {booking.child_age && <><br /><small>{booking.child_age} Jahre</small></>}
                                            </td>
                                            <td>
                                                <span className={`badge ${booking.status === 'confirmed' ? 'bg-success' : 'bg-secondary'}`}>
                                                    {booking.status === 'confirmed' ? 'Bestaetigt' : booking.status}
                                                </span>
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-sm btn-outline-primary me-1"
                                                    onClick={() => handleResendBundleConfirmation(booking.id)}
                                                    title="Bestaetigungs-E-Mail erneut senden"
                                                >
                                                    E-Mail
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => handleCancelBundleBooking(booking.id)}
                                                >
                                                    Stornieren
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default FeriencampsManager;
